import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconForkCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconForkCode"><Circle cx="6" cy="6" r="2.5" stroke="currentColor"/><Circle cx="12" cy="18" r="2.5" stroke="currentColor"/><Circle cx="18" cy="6" r="2.5" stroke="currentColor"/><Path d="M6 8.5V12H12V15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18 8.5V12H12V15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconForkCode;
